if (typeof window !== 'undefined') {
  window.global ||= window;
}

// add the values from import.meta.env to process.env

Object.entries(import.meta.env).forEach(([key, value]) => {
  process.env[key] = value;
});
